module.exports = __webpack_public_path__ + "img/job-light-manual.2e086a48.svg";